import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "drafts" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "white__navbar" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Черновики")
], -1)
const _hoisted_3 = { class: "drafts__content" }
const _hoisted_4 = { class: "search" }
const _hoisted_5 = { class: "data" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { style: {"color":"rgba(0, 0, 0, 0.4509803922)"} }, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-left",
      style: {"width":"76px"}
    }, " № "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-left",
      style: {"width":"120px"}
    }, " Дата создания "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-left",
      style: {"width":"160px"}
    }, " Дата редактирования "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-left",
      style: {"width":"280px"}
    }, " Юридическое лицо "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Адрес "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-left",
      style: {"width":"110px"}
    }, " Статус "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-left",
      style: {"width":"80px"}
    }),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-left",
      style: {"width":"62px"}
    }, " Избранное "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-left",
      style: {"width":"62px"}
    }, " Операции ")
  ])
], -1)
const _hoisted_7 = { style: {"text-align":"left"} }
const _hoisted_8 = { style: {"width":"76px"} }
const _hoisted_9 = { class: "text-left" }
const _hoisted_10 = {
  key: 0,
  style: {"font-weight":"bold","color":"#2F80ED"}
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = {
  class: "text-left",
  style: {"text-align":"center !important"}
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  class: "text-left",
  style: {"text-align":"center !important"}
}
const _hoisted_17 = { style: {"width":"62px"} }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 0,
  style: {"position":"absolute","width":"200px","margin-left":"-180px","margin-top":"-35px","z-index":"1","text-align":"center","background":"white","-webkit-user-select":"none","-moz-user-select":"none","-ms-user-select":"none","user-select":"none","box-shadow":"0px 20px 22px 0px #B2BDE169"}
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Info = _resolveComponent("Info")!
  const _component_Star = _resolveComponent("Star")!
  const _component_Dots = _resolveComponent("Dots")!
  const _component_LogoutIcon = _resolveComponent("LogoutIcon")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_vue_awesome_paginate = _resolveComponent("vue-awesome-paginate")!
  const _component_ModalStatement = _resolveComponent("ModalStatement")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: "Поиск",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search_value) = $event))
          }, null, 512), [
            [_vModelText, _ctx.search_value]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_v_table, { "fixed-header": "" }, {
            default: _withCtx(() => [
              _hoisted_6,
              _createElementVNode("tbody", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.doc_favorite_lists, (input, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", _hoisted_8, _toDisplayString(input.id), 1),
                    _createElementVNode("td", null, _toDisplayString(input.date), 1),
                    _createElementVNode("td", null, _toDisplayString(input.date_edit), 1),
                    _createElementVNode("td", null, _toDisplayString(input.client_name), 1),
                    _createElementVNode("td", null, _toDisplayString(input.address), 1),
                    _createElementVNode("td", _hoisted_9, [
                      (input.complete=='1')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, "Готово"))
                        : _createCommentVNode("", true),
                      (input.complete=='0')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, "Шаг " + _toDisplayString(input.step), 1))
                        : _createCommentVNode("", true),
                      (input.complete=='0')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Number(input.step_all), (n) => {
                              return (_openBlock(), _createElementBlock("div", null, [
                                _createElementVNode("div", {
                                  style: _normalizeStyle([{"width":"4px","height":"4px","background-color":"red","float":"left"}, (n>1?'margin-left: 2px; ':'')
                +
                (1==Number(input.step_arr[n-1])?'background-color: #03CB98;':'')
                +
                (n==Number(input.step) && 1==Number(input.step_arr[0]) ?'background-color: #2F80ED;':'')
                +
                (n==1 && 0==Number(input.step_arr[0])?'background-color: #2F80ED;':'')
                ])
                                }, null, 4)
                              ]))
                            }), 256))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_13, [
                      (input.complete == '1')
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            style: {"cursor":"pointer","color":"#2F80ED","text-decoration":"underline"},
                            onClick: ($event: any) => (_ctx.downloadFileFromURL('https://api.rekprof.ru/download.php?id='+input.id+'&hash='+_ctx.route.query.hash+'&type=document', 'дизайн проект №'+input.id+'.pdf'))
                          }, "Скачать", 8, _hoisted_14))
                        : (_openBlock(), _createElementBlock("span", _hoisted_15, [
                            _createVNode(_component_Info, {
                              style: {"margin-top":"6px","cursor":"pointer"},
                              onClick: ($event: any) => (_ctx.modalStat(input.id, input.step, input.step_all, input.step_arr, input.step_text))
                            }, null, 8, ["onClick"])
                          ]))
                    ]),
                    _createElementVNode("td", _hoisted_16, [
                      _createVNode(_component_Star, {
                        style: {"cursor":"pointer"},
                        onClick: ($event: any) => (_ctx.edit_favorite(input.id, input.hash, 1))
                      }, null, 8, ["onClick"])
                    ]),
                    _createElementVNode("td", _hoisted_17, [
                      _createElementVNode("div", {
                        class: "dots",
                        onClick: ($event: any) => (_ctx.context_detail=input.id)
                      }, [
                        _createVNode(_component_Dots)
                      ], 8, _hoisted_18),
                      (_ctx.context_detail==input.id)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createElementVNode("div", {
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.context_detail=0)),
                              style: {"text-align":"right"}
                            }, [
                              _createVNode(_component_LogoutIcon, { style: {"cursor":"pointer"} })
                            ]),
                            _createElementVNode("div", {
                              style: {"cursor":"pointer"},
                              onClick: ($event: any) => (_ctx.open_doc(input.id))
                            }, "Формирование заявления", 8, _hoisted_20),
                            _createElementVNode("div", {
                              style: {"cursor":"pointer"},
                              onClick: ($event: any) => (_ctx.copy_doc(input.id))
                            }, "Дублировать заявление", 8, _hoisted_21),
                            _createElementVNode("div", {
                              style: {"cursor":"pointer"},
                              onClick: ($event: any) => (_ctx.edit_favorite(input.id, input.hash, 1))
                            }, "Удалить из черновиков", 8, _hoisted_22)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_vue_awesome_paginate, {
        "total-items": _ctx.doc_favorite_list.length,
        "items-per-page": _ctx.pages_on_page,
        "max-pages-shown": 17,
        modelValue: _ctx.page,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.page) = $event)),
        "prev-button-content": "Назад",
        "next-button-content": "Далее",
        style: _normalizeStyle(
		'position: relative; float: left; transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1); margin-top: -0.5rem; top: 0px; left: 0px; margin-left: 1.5rem;'
		//'top: '+screen_h+'px;'
	)
      }, null, 8, ["total-items", "items-per-page", "modelValue", "style"])
    ]),
    (_openBlock(), _createBlock(_component_ModalStatement, {
      key: _ctx.del_key,
      is_open: _ctx.stat_modal,
      info_txt: _ctx.step_text,
      info_num: _ctx.del_num,
      step: _ctx.info_step,
      step_all: _ctx.step_all,
      step_arr: _ctx.step_arr,
      onDo_btn: _ctx.open_doc
    }, null, 8, ["is_open", "info_txt", "info_num", "step", "step_all", "step_arr", "onDo_btn"]))
  ], 64))
}